import { render, staticRenderFns } from "./ComenziDeb.vue?vue&type=template&id=f4715b00&scoped=true"
import script from "./ComenziDeb.vue?vue&type=script&lang=js"
export * from "./ComenziDeb.vue?vue&type=script&lang=js"
import style0 from "./ComenziDeb.vue?vue&type=style&index=0&id=f4715b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4715b00",
  null
  
)

export default component.exports